import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UIFlex from 'UIComponents/layout/UIFlex';
import styled from '../../components/Theme';
import FooterCopyright from './components/FooterCopyright';
import FooterLinks from './components/FooterLinks';
import FooterLogo from './components/FooterLogo';
const FooterWrapper = styled(UIFlex).withConfig({
  displayName: "FooterLayout__FooterWrapper",
  componentId: "w8ekx1-0"
})(["background-color:", ";padding:40px;@media (max-width:", "){padding:16px;}"], props => props.theme.colors.PANTERA, props => props.theme.sizes.GRID_BREAKPOINT_MEDIUM);
const FooterInnerWrapper = styled.div.withConfig({
  displayName: "FooterLayout__FooterInnerWrapper",
  componentId: "w8ekx1-1"
})(["max-width:", ";width:100%;display:grid;gap:10px;grid-template-areas:'logo children' 'copyright children';@media (max-width:", "){grid-template-areas:'logo' 'children' 'copyright';}"], props => props.theme.sizes.LAYOUT_NARROW_WIDTH, props => props.theme.sizes.GRID_BREAKPOINT_MEDIUM);
const LogoWrapper = styled(UIFlex).withConfig({
  displayName: "FooterLayout__LogoWrapper",
  componentId: "w8ekx1-2"
})(["grid-area:logo;@media (max-width:", "){padding-bottom:16px;}"], props => props.theme.sizes.GRID_BREAKPOINT_MEDIUM);
const CopyrightWrapper = styled(UIFlex).withConfig({
  displayName: "FooterLayout__CopyrightWrapper",
  componentId: "w8ekx1-3"
})(["grid-area:copyright;"]);
const ChildrenWrapper = styled(UIFlex).withConfig({
  displayName: "FooterLayout__ChildrenWrapper",
  componentId: "w8ekx1-4"
})(["grid-area:children;"]);

const FooterLayout = ({
  children = /*#__PURE__*/_jsx(FooterLinks, {}),
  copyright = /*#__PURE__*/_jsx(FooterCopyright, {}),
  logo = /*#__PURE__*/_jsx(FooterLogo, {})
}) => {
  return /*#__PURE__*/_jsx(FooterWrapper, {
    justify: "center",
    children: /*#__PURE__*/_jsxs(FooterInnerWrapper, {
      children: [/*#__PURE__*/_jsx(LogoWrapper, {
        children: logo
      }), /*#__PURE__*/_jsx(ChildrenWrapper, {
        children: children
      }), /*#__PURE__*/_jsx(CopyrightWrapper, {
        children: copyright
      })]
    })
  });
};

export default FooterLayout;